import React from 'react'
import { setKeyword, setResults, setTotalCount, setFullResults, setStartIndex, setLoading } from '../store/searchSlice'
import { getSearchResults } from '../../utils/Searchanise'
import { getProductsByHandles } from '../../utils/Product'
import { useSelector, useDispatch } from 'react-redux'

const FullSearch = () => {
  const { keyword, fullResultItems, startIndex, totalCount, loading } = useSelector((state) => state.search)
  const dispatch = useDispatch()
  const params = new URLSearchParams(window.location.search)
  const perPage = 6

  const fetchResults = (word, index = startIndex, append=false) => {
    dispatch(setLoading(true))
    getSearchResults((response) => {
      console.log(response)
      getProductsByHandles((results) => {
        if(append) {
          dispatch(setStartIndex(startIndex + perPage))
          dispatch(setFullResults(fullResultItems.concat(results)))
        } else {
          dispatch(setKeyword(word))
          dispatch(setResults(results.slice(0,4)))
          dispatch(setTotalCount(response.totalItems))
          dispatch(setFullResults(results))
        }
        
        setTimeout(() => {
          dispatch(setLoading(false))
          window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
        }, 50)
      }, response.items.slice(0,perPage).map((item) => `"${item['link'].replace('/products/', '')}"`))
    }, word, index)
  }

  if((keyword == null || keyword == '') && params.has('q') === true) {
    setTimeout(() => {
      fetchResults(params.get('q'))
    }, 2000)
  }
  
  return (
    <div className='product-grid-container min-h-[calc(100%-32rem)]' id='ProductGridContainer' data-products-grid>
      {totalCount == 0 && keyword != '' && 
        <div className="collection transition-width duration-150 ease-in-out w-full min-h-[9rem] lg:min-h-[18rem]" id="product-grid" data-paginator data-plp-paginator>
          <h2 className="text-center text-lg">
            No results found for “{ keyword }”. Check the spelling or use a different word or phrase.
          </h2>
        </div>
      }
      {
        totalCount > 0 &&
        <div className='collection transition-width duration-150 ease-in-out w-full'>
          <ul id="product-grid" className='product-grid'>
            {
              fullResultItems.map((result, index) => 
                <li className='lg:col-span-1' key={`full-search-${result.id}-${index}`}>
                  <div className='h-full' product-tile='true' props={JSON.stringify(result).replace("'", "’")}></div>
                </li>
              )
            }
          </ul>

          {
            startIndex + perPage < totalCount &&
            <div className="flex flex-col gap-4 items-center justify-center mt-16 lg:mt-20" data-pagination-nav>
              <button className="button button--secondary mx-auto inline-block relative"
                onClick={() => fetchResults(keyword, startIndex + perPage, true)} 
                data-load-more 
                disabled={loading}
              >
                More Results
                {loading && <span className='search-loader absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' />}
              </button>
              <span data-items-text>{ Math.min(startIndex + perPage, totalCount) } of { totalCount } Products </span>
            </div>
          }
        </div>
      }
    </div>
  )
}

export default FullSearch